import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import { ref } from 'vue';
import { supplierExportCongApiService } from 'src/services';

export const useSupplierExportConfigurationStore = defineStore(
  'supplier_export_configuration',
  {
    state: () => ({
      processing: ref(false),
      current_model: {} as dynamicObj,
    }),
    getters: {},
    actions: {
      async getSupplierExportConfig() {
        try {
          const rs = await supplierExportCongApiService.getSupplierExport();
          if (rs.success) {
            this.current_model.url = rs?.data?.create_supplier_config?.url;
            this.current_model.idm_url = rs?.data?.upload_documents_config?.url;
            this.current_model.data_mapping =
              rs?.data?.create_supplier_config?.data_mapping;
            this.current_model.create_supplier_config =
              rs?.data?.upload_documents_config;
            this.current_model.upload_documents_config =
              rs?.data?.upload_documents_config;
            this.current_model.api_supplier_details =
              rs?.data?.api_supplier_details;
          }
          if (rs.success === false) {
            throw rs;
          }
        } catch (error) {
          throw error;
        }
      },
      async submitUSeDefault() {
        this.processing = true;
        try {
          const rs = await supplierExportCongApiService.submitUSeDefault();
          if (rs.success === false) {
            throw rs;
          }

          this.current_model.url = rs?.data?.url;
          this.current_model.data_mapping = rs?.data?.data_mapping;
        } catch (error) {
          console.error('Error in submitUSeDefault:', error);
        } finally {
          this.processing = false;
        }
      },
      async downloadFile(call_type: string, fileName: string) {
        try {
          const data: dynamicObj = {
            call_type: call_type,
          };
          const rs = await supplierExportCongApiService.downloadApiConfig(data);
          if (rs.error) {
            throw rs.error;
          }
          const fileURL = window.URL.createObjectURL(new Blob([rs]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          fileLink.remove();
        } catch (error) {
          console.error('Error downloading file:', error);
        }
      },
      async submitExportConfig() {
        try {
          const data: {
            url: string;
            data_mapping: string;
            idm_url?: string;
            file?: File;
            idm_file?: File;
          } = {
            url: this.current_model.url,
            data_mapping: this.current_model.data_mapping,
            idm_url: this.current_model.idm_url,
          };

          if (this.current_model.file) {
            data.file = this.current_model.file;
          }

          if (this.current_model.idm_file) {
            data.idm_file = this.current_model.idm_file;
          }

          const response =
            await supplierExportCongApiService.submitExportConfig(data);
          if (response.success === false) {
            throw response;
          }
        } catch (error) {
          throw error;
        }
      },
    },
  }
);